import type { Distance } from "@pdfking/math"

import type { BoxPointList, BoxPointLists } from "#internal"

export const PointAccumulate = (...points_list: BoxPointList[]): BoxPointLists =>
  points_list
    .filter(points => points.length > 0)
    .map(points => {
      let x = 0
      let y = 0
      return points.map(point => {
        x += point.x
        y += point.y
        return { ...point, x: x as Distance, y: y as Distance }
      })
    })
